import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, ArrowRightIcon } from '@heroicons/react/24/outline';

const LandlordRulesInsight: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-6 shadow-sm">
      <div className="flex items-start gap-4">
        {/* Icon */}
        <div className="flex-shrink-0">
          <BookOpenIcon className="h-8 w-8 text-blue-600" aria-hidden="true" />
        </div>

        {/* Content */}
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Stay Updated on Irish Landlord Rules 2026
          </h3>
          <p className="text-gray-700 mb-4">
            New regulations and compliance requirements are shaping Ireland's rental market. Learn
            about the latest changes to help you manage your properties effectively and stay within
            the law.
          </p>

          {/* Link with Icon */}
          <Link
            to="/blog/irish-landlord-rules-2026"
            className="no-underline inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors group"
          >
            <span>Read the Latest Rules</span>
            <ArrowRightIcon
              className="h-4 w-4 group-hover:translate-x-1 transition-transform"
              aria-hidden="true"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LandlordRulesInsight;
